import type { PlanSettings } from '../../api/types';

/** True when someone has asked for Plan My Week mail that will never arrive.
 *
 *  An empty `subscribed_reps` means "my own territory", so a manager with no territory of their
 *  own is subscribed to nobody. Launch week, and still three weeks later, a manager with both
 *  emails on had been skipped every morning. `own_rep` absent (an older backend) is treated as
 *  unknown, not as "none". */
export function emailsSendNothing(settings: PlanSettings | null | undefined): boolean {
  if (!settings) return false;
  const wantsMail = Boolean(settings.weekly_email || settings.daily_digest);
  return wantsMail && !(settings.subscribed_reps ?? []).length && settings.own_rep === null;
}
